import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  coursesForDepartment(event: Event) {
    const ele = this.element as HTMLElement;
    const tomSelectElement = event.target as HTMLSelectElement;
    const selectedDepartmentId = tomSelectElement.value;
    const userId = ele.dataset.employmentUserId;
    const employmentId = ele.dataset.employmentEmploymentId;
    const xhr = new XMLHttpRequest();

    xhr.open(
      "GET",
      `/users/${userId}/employments/courses_for_department?department_id=${selectedDepartmentId}&employment_id=${employmentId}`,
      true
    );
    xhr.responseType = "text";

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        const data = xhr.response;
        const partialElement = document.querySelector("#partial");

        if (partialElement) {
          partialElement.innerHTML = data;
          window.initializeTomSelects();
        }
      }
    };

    xhr.send();
  }
}
